import React, { CSSProperties, PropsWithChildren } from 'react';
import { DialogTitleText } from './DialogTitleText';
import { DialogTitleRoot } from './DialogTitleRoot';
import { DialogTitleActions } from './DialogTitleActions';

interface DialogTitleClasses {
  root?: string;
  titleText?: string;
  closeButton?: string;
}

interface DialogTitleStyles {
  root?: CSSProperties;
  titleText?: CSSProperties;
  actionButton?: CSSProperties;
}

/**We will expose this one to the host */
export interface DialogTitleProps {
  titleText?: string;
  classes?: DialogTitleClasses;
  styles?: DialogTitleStyles;
  additionalActions?: React.ReactNode;
}

export interface DialogTitleComponentProps extends DialogTitleProps {
  isFullScreen?: boolean;
  draggableId?: string;
  onClose?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onFullScreen?: () => void;
  disableFullScreenAction?: boolean;
}

export function DialogTitle(props: PropsWithChildren<DialogTitleComponentProps>) {
  return (
    <DialogTitleRoot className="dp-dialog-title" {...props}>
      <DialogTitleText className="dp-dialog-title__text" {...props}>
        {props.titleText}
      </DialogTitleText>
      <DialogTitleActions className="dp-dialog-title__actions" {...props} />
    </DialogTitleRoot>
  );
}
